import { ILogger } from '@tdp/common/telemetry';
import { IThemeReader, Theme } from '@tdp/common/theme';

export interface IThemeClientServiceDeps {
  logger: ILogger;
}

export class WebThemeReader implements IThemeReader {
  private window: Pick<Window, 'matchMedia'>;

  constructor({ window }: { window: Pick<Window, 'matchMedia'> }) {
    this.window = window;
  }

  getTheme(): Promise<Theme> {
    return Promise.resolve(this.getCurrentTheme());
  }

  onThemeChange(callback: (theme: Theme) => void): void {
    this.window
      .matchMedia('(prefers-color-scheme: dark),(forced-colors: active)')
      .addEventListener('change', () => {
        callback(this.getCurrentTheme());
      });
  }

  private getCurrentTheme(): Theme {
    const isHighContrast = this.window.matchMedia(
      '(forced-colors: active)'
    ).matches;
    if (isHighContrast) {
      return 'contrast';
    }
    const isDarkMode = this.window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;
    return isDarkMode ? 'dark' : 'light';
  }
}
